// import React, { useEffect, useState } from "react";
// import apiService from "../utils/apiService";
// import '../../Components/common/Modal/modal.css';
// import '../../Components/common/css/pw_push5.css';
// import '../common/css/foldertrack.css';
// import TablePagination from '@mui/material/TablePagination';

// const TrackOwnerData = () => {
//    const [tableData, setTableData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//  const [currentPage, setCurrentPage] = useState(1);
//  const [rowsPerPage, setRowsPerPage] = useState(10);
//  const [page, setPage] = useState(0);
//   // Slice the data for pagination
//   // const indexOfLastItem = (page + 1) * rowsPerPage;
//   // const indexOfFirstItem = indexOfLastItem - rowsPerPage;
//   // const currentItems = tableData.slice(indexOfFirstItem, indexOfLastItem);
  
  
//   const [searchTerm, setSearchTerm] = useState("");
//   const fetchTrackOwnerData = async () => {
//     try {
//        setLoading(true);
//        setError(null);

//       // Replace with your actual endpoint URL      
//       const response = await apiService.get("/foldermetadata");
//       if (response.data.data && Array.isArray(response.data.data)) {        
//         setTableData(response.data.data);
//       } else {
//         setTableData([]);
//       }
//     } catch (err) {
//       console.error("Error fetching track owner data:", err);
//       setError("Failed to load data. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     // Call API when the navigation triggers this component    
//     fetchTrackOwnerData();
//     setRowsPerPage(10);
//   }, []);
  
//    const handlePageChange = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const filteredData = tableData.filter((item) =>
//     item.foldercreatedby?.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const indexOfLastItem = (page + 1) * rowsPerPage;
//   const indexOfFirstItem = indexOfLastItem - rowsPerPage;
//   const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

//   // Search handler
//   const handleSearchChange = (event) => {
//     setSearchTerm(event.target.value);
//     setPage(0); // Reset to first page on new search
//   };

//   return (
//     <div className="container mt-4">
//       <h4 className="mb-3">User Activity History</h4>

//      {/* Search box with clear (×) icon */}
//     {tableData.length > 0 && (
//       <div className="search-container">
//         <input
//           type="text"
//           placeholder="Search by Created By..."
//           value={searchTerm}
//           onChange={handleSearchChange}
//           className="search-input"
//         />
//         {searchTerm && (
//           <button className="clear-button" onClick={() => setSearchTerm("")}>
//             ×
//           </button>
//         )}
//       </div>
//     )}
//       {loading ? (
//         <p>Loading data...</p>
//       ) : error ? (
//         <p className="text-danger">{error}</p>
//       ) : (
//         <div className="table-wrapper">
//           <table className="custom-table">
//             <thead>
//               <tr>
//                 <th>Created By</th>
//                 <th>Last Modified By</th>
//                 <th>Parent Location</th>
//                 <th>Created Path</th>
//                 <th>Last Modified Path</th>
//                 <th>Created Date</th>
//                 <th>Modified Date</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentItems.length > 0 ? (
//                 currentItems.map((item, index) => (
//                   <tr key={index}>
//                     <td>{item.foldercreatedby || "-"}</td>
//                     <td>{item.foldermodifiedby || "-"}</td>
//                     <td>{item.folderparentpath || "-"}</td>
//                     <td>{item.foldercreatedpath || "-"}</td>
//                     <td>{item.foldermodifiedpath || "-"}</td>
//                     <td>
//                       {item.foldercreateddate
//                         ? new Date(item.foldercreateddate).toLocaleString()
//                         : "-"}
//                     </td>
//                     <td>
//                       {item.foldermodifieddate
//                         ? new Date(item.foldermodifieddate).toLocaleString()
//                         : "-"}
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="7" className="text-center">
//                     No data available
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//  <TablePagination
//           rowsPerPageOptions={[5, 10, 20, 50]}
//           colSpan={3}
//           count={filteredData?.length}
//           rowsPerPage={rowsPerPage}
//           page={page}
//           onPageChange={handlePageChange}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//           style={{ float: 'right', margin: '16px' }}
//           SelectProps={{
//             inputProps: {
//                'aria-label': 'rows per page',
//             },
//             native: true,
//           }}
//         />
//         </div>
//       )}
//     </div>
//   );
// };
// export default TrackOwnerData;

import React, { useEffect, useState } from "react";
import apiService from "../utils/apiService";
import "../../Components/common/Modal/modal.css";
import "../../Components/common/css/pw_push5.css";
import "../common/css/foldertrack.css";
import TablePagination from "@mui/material/TablePagination";
import '../common/css/foldertrack.css';

const TrackOwnerData = () => {
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortField, setSortField] = useState("foldercreateddate"); //  Default sort field
  const [sortOrder, setSortOrder] = useState("asc"); //  Default sort order

  const fetchTrackOwnerData = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiService.get("/foldermetadata");

      if (response.data.data && Array.isArray(response.data.data)) {
        const data = response.data.data;

        //  Default sort (Created Date Asc)
        const sorted = [...data].sort(
          (a, b) => new Date(a.foldercreateddate) - new Date(b.foldercreateddate)
        );

        setTableData(sorted);
        setFilteredData(sorted);
      } else {
        setTableData([]);
        setFilteredData([]);
      }
    } catch (err) {
      console.error("Error fetching track owner data:", err);
      setError("Failed to load data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTrackOwnerData();
  }, []);

  //  Search logic
  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    const filtered = tableData.filter(
      (item) =>
        item.foldercreatedby?.toLowerCase().includes(value) ||
        item.foldermodifiedby?.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
    setPage(0);
  };

  const clearSearch = () => {
    setSearchTerm("");
    setFilteredData(tableData);
    setPage(0);
  };

  //  Sorting logic
  const handleSort = (field) => {
    const order = sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(order);

    const sorted = [...filteredData].sort((a, b) => {
      const dateA = new Date(a[field]);
      const dateB = new Date(b[field]);
      return order === "asc" ? dateA - dateB : dateB - dateA;
    });
    setFilteredData(sorted);
  };

  //  Pagination logic
  const indexOfLastItem = (page + 1) * rowsPerPage;
  const indexOfFirstItem = indexOfLastItem - rowsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className="container mt-4">
      <h4 className="mb-3">User Activity History</h4>

      {!loading && tableData.length > 0 && (
        <div className="search-container">
          <input
            type="text"
            placeholder="Search by Created or Last Modified By..."
            value={searchTerm}
            onChange={handleSearchChange}
            className="search-input"
          />
          {searchTerm && (
            <button className="clear-button" onClick={clearSearch}>
              ×
            </button>
          )}
        </div>
      )}

      {loading ? (
        <p>Loading data...</p>
      ) : error ? (
        <p className="text-danger">{error}</p>
      ) : (
        <div className="table-wrapper">
          <table className="custom-table">
            <thead>
              <tr>
                <th>Created By</th>
                <th>Last Modified By</th>
                <th>Parent Location</th>
                <th>Created Path</th>
                <th>Last Modified Path</th>
               <th
  className="sortable"
  onClick={() => handleSort("foldercreateddate")}
>
  Created Date{" "}
  <span
    className={
      sortField === "foldercreateddate"
        ? "sort-icon active"
        : "sort-icon inactive"
    }
  >
    {sortField === "foldercreateddate" && sortOrder === "desc" ? "▼" : "▲"}
  </span>
</th>
<th
  className="sortable"
  onClick={() => handleSort("foldermodifieddate")}
>
  Modified Date{" "}
  <span
    className={
      sortField === "foldermodifieddate"
        ? "sort-icon active"
        : "sort-icon inactive"
    }
  >
    {sortField === "foldermodifieddate" && sortOrder === "desc" ? "▼" : "▲"}
  </span>
</th>

              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((item, index) => (
                  <tr key={index}>
                    <td>{item.foldercreatedby || "-"}</td>
                    <td>{item.foldermodifiedby || "-"}</td>
                    <td>{item.folderparentpath || "-"}</td>
                    <td>
  {item.foldercreatedpath
    ? (
        <ol className="numbered-list">
          {item.foldercreatedpath.split(",").map((path, idx) => (
            <li key={idx}>{idx + 1}.{path.trim()}</li>
          ))}
        </ol>
      )
    : "-"}
</td>
<td>
  {item.foldermodifiedpath
    ? (
        <ol className="numbered-list">
          {item.foldermodifiedpath.split(",").map((path, idx) => (
            <li key={idx}>{idx + 1}.{path.trim()}</li>
          ))}
        </ol>
      )
    : "-"}
</td>


                    <td>
                      {item.foldercreateddate
                        ? new Date(item.foldercreateddate).toLocaleString()
                        : "-"}
                    </td>
                    <td>
                      {item.foldermodifieddate
                        ? new Date(item.foldermodifieddate).toLocaleString()
                        : "-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <TablePagination
            rowsPerPageOptions={[5, 10, 20, 50]}
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleChangeRowsPerPage}
            style={{ float: "right", margin: "16px" }}
            SelectProps={{
              inputProps: { "aria-label": "rows per page" },
              native: true,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default TrackOwnerData;
